import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import CreatableSelectField from 'CommonComponents/CreatableSelectField';
import ModalFooter from 'CommonComponents/ModalFooter';
import TextFormField from 'CommonComponents/TextFormField';

const SportAthletesCreateSchema = Yup.object().shape({
    firstName: Yup.string(),
    lastName: Yup.string(),
    nationality: Yup.string(),
    gender: Yup.string(),
});

const genders = [
    { value: '', label: $t('Undisclosed') },
    { value: 'Male', label: $t('Male') },
    { value: 'Female', label: $t('Female') },
];

export default function SportAthletesCreateForm(props) {
    return (
        <Formik
            initialValues={{
                firstName: '',
                lastName: '',
                nationality: '',
                gender: '',
            }}
            validationSchema={SportAthletesCreateSchema}
            onSubmit={(values, actions) => {
                const doSave = () => {
                    axios
                        .post(props.sportAthletesStoreUrl, {
                            first_name: values.firstName,
                            last_name: values.lastName,
                            nationality: values.nationality,
                            gender: values.gender,
                        })
                        .then(() => {
                            props.setSportAthleteIsUpdated(true);
                            if (window.quantityLinkEnabled) {
                                window.currentSportAthleteCount = (window.currentSportAthleteCount || 0) + 1;
                                window.currentTotalAthleteCount = (window.currentTotalAthleteCount || 0) + 1;
                            }
                        })
                        .catch((e) => {
                            actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                            actions.resetForm();
                        });
                };

                if (window.quantityLinkEnabled && window.quantityLinkDriverImpactPreviewUrl) {
                    const baseUrl = window.quantityLinkDriverImpactPreviewUrl;

                    const sportParams = new URLSearchParams({
                        source_type: 'App\\Sport',
                        source_id: String(window.sportSourceId),
                    });

                    const eventParams = new URLSearchParams({
                        source_type: 'App\\Event',
                        source_id: String(window.eventSourceId),
                        driver: 'athlete_count',
                    });

                    const checkEventLevel = () => {
                        window.dispatchEvent(
                            new CustomEvent('quantityimpact:check', {
                                detail: {
                                    previewUrl: baseUrl + '?' + eventParams.toString(),
                                    newValue: (window.currentTotalAthleteCount || 0) + 1,
                                    formEl: null,
                                    onConfirm: doSave,
                                },
                            }),
                        );
                    };

                    window.dispatchEvent(
                        new CustomEvent('quantityimpact:check', {
                            detail: {
                                previewUrl: baseUrl + '?' + sportParams.toString(),
                                newValue: (window.currentSportAthleteCount || 0) + 1,
                                formEl: null,
                                onConfirm: checkEventLevel,
                            },
                        }),
                    );
                } else {
                    doSave();
                }
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('First Name')} type="text" name="firstName" placeholder={$t('First Name')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Last Name')} type="text" name="lastName" placeholder={$t('Last Name')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor="nationality" className="text-input__label">
                                {$t('Nationality')}
                            </label>
                            <CreatableSelectField
                                options={props.nationalities}
                                value={values.nationality}
                                onChange={(value) => setFieldValue('nationality', value.value)}
                            />
                            {errors.nationality && touched.nationality ? <div className="tw-text-red-500 tw-text-sm">{errors.nationality}</div> : null}
                        </div>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor="gender" className="text-input__label">
                                {$t('Gender')}
                            </label>
                            <CreatableSelectField options={genders} value={values.gender} onChange={(value) => setFieldValue('gender', value.value)} />
                            {errors.gender && touched.gender ? <div className="tw-text-red-500 tw-text-sm">{errors.gender}</div> : null}
                        </div>
                    </div>
                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
